const loginUri = window.location.hostname.includes("localhost")
  ? "http://a.m.localhost:3301/login"
  : "/login";

function getRedirectToLoginUri() {
  return `${loginUri}?redirect=${encodeURI(window.location.pathname + window.location.search)}`;
}

export default getRedirectToLoginUri;
